(function () {
  const { starryScriptURLs, starryStyleURLs } = window;
  console.log(starryScriptURLs, starryStyleURLs)
  const starryAssets = {
    js: {
      urls: starryScriptURLs,
      load: starryLoadJS,
    },
    css: {
      urls: starryStyleURLs,
      load: starryLoadCSS,
    },
  };

  function starryLoadJS(src) {
    let target =
      arguments.length > 1 && arguments[1] !== undefined
        ? arguments[1]
        : document.body;
    let async =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    let defer =
      arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    return new Promise((resolve, reject) => {
      const doc = target.ownerDocument;
      const currScript = doc.querySelector(`script[src="${src}"]`);

      if (currScript) {
        if (currScript.dataset.loaded) return resolve(true);
        currScript.addEventListener("load", () => {
          currScript.dataset.loaded = true;
          resolve(true);
        });
        return;
      }

      const script = doc.createElement("script");
      script.src = src;
      script.async = async;
      script.defer = defer;
      script.addEventListener("load", () => {
        script.dataset.loaded = true;
        resolve(true);
      });
      script.onerror = reject;
      target.appendChild(script);
    });
  }
  function starryLoadCSS(href) {
    let target =
      arguments.length > 1 && arguments[1] !== undefined
        ? arguments[1]
        : document.head;
    return new Promise((resolve, reject) => {
      const doc = target.ownerDocument;
      const currLink = doc.querySelector(`link[href="${href}"]`);

      if (currLink) {
        if (currLink.dataset.loaded) return resolve(true);
        currLink.addEventListener("load", () => {
          currLink.dataset.loaded = true;
          resolve(true);
        });
        return;
      }

      const link = doc.createElement("link");
      link.rel = "stylesheet";
      link.href = href;
      link.addEventListener("load", () => {
        link.dataset.loaded = true;
        resolve(true);
      });
      link.onerror = reject;
      target.appendChild(link);
    });
  }

  function starryLoadAssets(param) {
    for (
      var _len = arguments.length,
        rest = new Array(_len > 1 ? _len - 1 : 0),
        _key = 1;
      _key < _len;
      _key++
    ) {
      rest[_key - 1] = arguments[_key];
    }
    return new Promise((resolve, reject) => {
      const files = typeof param === "string" ? [param] : param;

      Promise.all(
        files.map(async (file) => {
          try {
            const [, name, type] = file.match(/(.*)\.(js|css)$/) || [
              ,
              file,
              "js",
            ];
            const {
              urls: {
                [name]: { url },
              },
              load,
            } = starryAssets[type];
            await load(url, ...rest);
            // log(`${name}.${type}`);
          } catch (err) {
            console.warn(`Failed to load asset: ${file}.`, err);
          }
        })
      )
        .then(resolve)
        .catch(reject);
    });
  }

  // 轮播图初始化
  const starrySwiperDom = document.querySelector(".starry_swiper");
  console.log("starrySwiperDom", starrySwiperDom);
  if (starrySwiperDom) {
    starryLoadAssets(["swiper.css", "swiper.js"]).then(() => {
      console.log("执行轮播图");
      window.starryEventBus.emit("initStarrySwiper");
    });
  }

  // 数字累加动画初始化
  const starryCountDom = document.querySelector(".starry_count");
  if (starryCountDom) {
    starryLoadAssets(["countUp.js"]).then(() => {
      window.starryEventBus.emit("initStarryCount");
    });
  }
  // 视差滚动动画初始化
  const starryScrollTriggerDom = document.querySelector(
    ".starry_gsap_scroll_trigger"
  );
  if (starryScrollTriggerDom) {
    starryLoadAssets(["gsap.js", "ScrollTrigger.js"]).then(() => {
      window.starryEventBus.emit("initStarryScrollTrigger");
    });
  }



  // 滚动动画初始化
  const STARRY_ANIMATION_TRIGGER_CLASSNAME = "starry_scroll_trigger";
  const STARRY_SCROLL_ANIMATION_OFFSCREEN_CLASSNAME =
    "starry_scroll_trigger_offscreen";
  const STARRY_SCROLL_ANIMATION_CANCEL_CLASSNAME =
    "starry_scroll_trigger_cancel";

  function onIntersection(elements, observer) {
    console.log("elements", elements);
    elements.forEach((element, index) => {
      if (element.isIntersecting) {
        const elementTarget = element.target;
        if (
          elementTarget.classList.contains(
            STARRY_SCROLL_ANIMATION_OFFSCREEN_CLASSNAME
          )
        ) {
          elementTarget.classList.remove(
            STARRY_SCROLL_ANIMATION_OFFSCREEN_CLASSNAME
          );
          if (elementTarget.hasAttribute("data-cascade")) {
            elementTarget.setAttribute("style", `--animation-order: ${index};`);
          }
        }
        observer.unobserve(elementTarget);
      } else {
        element.target.classList.add(
          STARRY_SCROLL_ANIMATION_OFFSCREEN_CLASSNAME
        );
        element.target.classList.remove(
          STARRY_SCROLL_ANIMATION_CANCEL_CLASSNAME
        );
      }
    });
  }

  function initializeScrollAnimationTrigger(rootEl = document) {
    const animationTriggerElements = Array.from(
      rootEl.getElementsByClassName(STARRY_ANIMATION_TRIGGER_CLASSNAME)
    );
    if (animationTriggerElements.length === 0) return;
    const currentScrollPosition = window.scrollY + window.innerHeight;

    // 过滤掉那些已经在当前视口之上的元素
    const elementsToObserve = animationTriggerElements.filter((element) => {
      const elementTopPosition =
        element.getBoundingClientRect().top + window.scrollY;
      if (elementTopPosition < currentScrollPosition) {
        // 移除动画类和触发类
        element.classList.remove(STARRY_SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        element.classList.remove(STARRY_ANIMATION_TRIGGER_CLASSNAME);
        return false; // 不需要观察
      }
      return true; // 需要观察
    });

    const observer = new IntersectionObserver(onIntersection, {
      rootMargin: "0px 0px -50px 0px",
    });
    elementsToObserve.forEach((element) => observer.observe(element));
  }

  window.addEventListener("load", () => {
    console.log("load global");
    initializeScrollAnimationTrigger();
  });
})();
